import React from 'react';
import './Welcome.css'; // Import the CSS for styles
import { useNavigate } from 'react-router-dom';

function Welcome() {

    const Navugate = useNavigate()
    const Handlenaviagte = () => {
        Navugate('/')
    }
    return (
        <div className="welcome-container">
            <div className="">
                <h1 className="welcome-message">Welcome to</h1>
                <h2 className="company-name">Leadsense Media India Pvt Ltd</h2>
                <button onClick={Handlenaviagte} className='btn btn-primary'>Go back to login</button>
            </div>
        </div>
    );
}

export default Welcome;
